import classnames from "classnames";
import { nb } from "date-fns/locale";
import PropTypes from "prop-types";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { parseDate } from "../../../utils/date";
import "./ReactDatepickerExtention.css";
import "./TextInput.css";

// Register Norwegian locale once
registerLocale("nb", nb);

/**
 * Native Date wrapper around react-datepicker.
 * Contract: emits an event-like object { target: { name, value, formatedValue } }
 * - value: Date | "" when cleared
 * - formatedValue: ISO string or ""
 */
export default function DatePickerNative({
  id,
  name,
  label,
  value,
  onChange,
  placeholder,
  validationError,
  minDate,
  maxDate,
  disabled,
}) {
  const selected = parseDate(value);

  const handleChange = (date) => {
    const v = date || "";
    const formatedValue =
      date instanceof Date && !Number.isNaN(date.getTime())
        ? date.toISOString()
        : "";
    onChange({
      target: {
        id: id || name,
        name: name || id,
        value: v,
        formatedValue,
      },
    });
  };

  return (
    <div
      className={classnames(
        "mb-3",
        validationError ? { "has-error": validationError } : "",
      )}
    >
      {label && (
        <label className="control-label" htmlFor={id || name}>
          {label}
        </label>
      )}
      <div>
        <DatePicker
          id={id}
          selected={selected}
          onChange={handleChange}
          placeholderText={placeholder}
          dateFormat="dd.MM.yyyy"
          locale="nb"
          isClearable
          minDate={minDate}
          maxDate={maxDate}
          disabled={disabled}
          showMonthDropdown
          showYearDropdown
          dropdownMode="select"
          showPopperArrow={false}
          className="form-control"
          autoComplete="off"
        />
      </div>
      {validationError && (
        <span className="validation-error">{validationError}</span>
      )}
    </div>
  );
}

DatePickerNative.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  validationError: PropTypes.string,
  minDate: PropTypes.instanceOf(Date),
  maxDate: PropTypes.instanceOf(Date),
  disabled: PropTypes.bool,
};
